module.exports = __webpack_public_path__ + "img/residential-template.0a240cbb.png";